import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

interface IAnalyticsSidePanelLayout {
  hasSidePanel: boolean;
}

export const StyledAnalyticsRoot = styled(Box)({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  overflowX: "hidden",
  overflow: "auto",
});

export const StyledAnalyticsToolbar = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  alignItems: "center",
  gap: theme.spacing(1),
  marginBottom: theme.spacing(2),
  minWidth: 0,
  overflow: "hidden",
  flexShrink: 0,
}));

export const StyledAnalyticsControls = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(2),
}));

export const StyledAnalyticsContent = styled(Box, {
  shouldForwardProp: prop => prop !== "hasSidePanel",
})<IAnalyticsSidePanelLayout>(({ theme, hasSidePanel }) => ({
  flex: 1,
  minHeight: 300,
  overflow: "hidden",
  display: "flex",
  flexDirection: hasSidePanel ? "row" : "column",
  alignItems: "stretch",
  gap: hasSidePanel ? theme.spacing(1.5) : 0,
}));

export const StyledAnalyticsViewPanel = styled(Box)({
  flex: 1,
  minWidth: 0,
  minHeight: 0,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
});

export const StyledAnalyticsBottomControls = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  marginTop: theme.spacing(1),
}));
